import { Store } from 'vuex'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.SaleCategoryCreated',
    callback: (category: KwixeoCatalog.SaleCategory): void => {
      store.dispatch('catalog/setSaleCategory', category)
    }
  },
  {
    name: '.SaleCategoryUpdated',
    callback: (category: KwixeoCatalog.SaleCategory): void => {
      store.dispatch('catalog/setSaleCategory', category)
    }
  },
  {
    name: '.SaleCategoryDeleted',
    callback: (category: KwixeoCatalog.SaleCategory): void => {
      store.dispatch('catalog/deleteSaleCategory', category)
    }
  },

  {
    name: '.ChargeCategoryCreated',
    callback: (category: KwixeoCatalog.ChargeCategory): void => {
      store.dispatch('catalog/setChargeCategory', category)
    }
  },
  {
    name: '.ChargeCategoryUpdated',
    callback: (category: KwixeoCatalog.ChargeCategory): void => {
      store.dispatch('catalog/setChargeCategory', category)
    }
  },
  {
    name: '.ChargeCategoryDeleted',
    callback: (category: KwixeoCatalog.ChargeCategory): void => {
      store.dispatch('catalog/deleteChargeCategory', category)
    }
  },

  {
    name: '.VariationCreated',
    callback: (variationLevel: KwixeoCatalog.VariationLevel): void => {
      store.dispatch('catalog/setVariationLevel', variationLevel)
    }
  },
  {
    name: '.VariationUpdated',
    callback: (variationLevel: KwixeoCatalog.VariationLevel): void => {
      store.dispatch('catalog/setVariationLevel', variationLevel)
    }
  },
  {
    name: '.VariationDeleted',
    callback: (variationLevel: KwixeoCatalog.VariationLevel): void => {
      store.dispatch('catalog/deleteVariationLevel', variationLevel)
    }
  }
])
